<template>
  <div class="clazz" v-if="isLoaded">
    <van-nav-bar
      title="班级详情"
      left-text=""
      right-text=""
      left-arrow
      @click-left="backToExplore"
    />
    <div class="header bgwhite">
      <img class="cover" v-lazy="clazz.cover_url">
      <div class="info" style="margin-bottom: 10px;">
        <div class="title">
          <span>{{ clazz.clazz_name }}</span>
          <!-- <div v-if="clazz.is_manager" class="btn" @click="gotoClazzmanage">管理后台</div> -->
        </div>
        <div class="subinfo">
          <div style="margin-bottom: 2px;">
            参与时间：{{ clazz.start_time_format2 }} ～ {{ clazz.end_time_format2 }}
            （{{ clazz.day_num }}天）
          </div>
          <div style="margin-bottom: 2px;">跑步天数：{{ clazz.run_days }}天 | 每天距离：{{ clazz.day_distance }}公里</div>
          <div style="margin-bottom: 2px;">报名截止：{{ clazz.enroll_end_time_format2 }}</div>
          <div style="margin-bottom: 2px;">已报名：{{ clazz.user_num }}人</div>
        </div>
      </div>
      <!-- <van-cell
        value-class="hg_cell__value"
        title="报名费"
        :value="'¥'+contractFee"
      /> -->
    </div>

    <van-tabs v-model="active" color="#f5222d" :sticky="true">
      <van-tab v-if="clazz.rule_intro" title="规则说明">
        <div class="clazz_rule_intro render-html" v-html="clazz.rule_intro"></div>
      </van-tab>
      <van-tab title="班级介绍">
        <div class="clazz_part render-html">
          <div v-html="clazz.intro_html"></div>
          <div v-if="!clazz.intro" class="empty">暂无班级介绍</div>
        </div>
      </van-tab>
      <van-tab title="班长简介">
        <div class="clazz_leader">
          <div class="leader_header">
            <img :src="clazz.creater.avatar_url" class="headimg">
            <div class="name">{{ clazz.creater.nickname }}</div>
          </div>
          <div class="leader_intro">
            {{ clazz.creater_intro }}
          </div>
        </div>
      </van-tab>
    </van-tabs>

    <tabbar-top/>
    <clazz-btn
      :check="enrollCheck"
      :clazz="clazz"
      @share="mask=true"
    />
    <!-- <goto-home /> -->

    <div class="mask" v-show="mask" @click="mask=false">
      <img src="../../assets/images/guide.png">
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Icon, Cell, CellGroup, NavBar, Tab, Tabs } from 'vant'
import TabbarTop from '@/components/TabbarTop'
import ClazzBtn from './components/ClazzBtn'
import GotoHome from '@/components/GotoHome'
import { clazzFullInfo, checkEnrolRecord } from '@/api/clazz'

export default {
  name: 'clazz',
  components: {
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [NavBar.name]: NavBar,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    TabbarTop,
    GotoHome,
    ClazzBtn
  },
  filters: {
    distance (value) {
      return value.mon.distance + value.tues.distance + value.wed.distance + value.thur.distance + value.fri.distance + value.sat.distance + value.sun.distance
    }
  },
  data () {
    return {
      isLoaded: false,
      active: 0,
      mask: false,
      show: false,
      enrollCheck: null,
      clazz: null
    }
  },
  computed: {
     ...mapGetters([
      'username',
    ]),
    contractFee () {
      return parseFloat(this.clazz.contract_fee)
    }
  },
  created () {
    let clazzId = this.$route.params.clazz_id || ''
    this.getClazzInfo(clazzId)
  },
  methods: {
    async getClazzInfo (clazzId) {
      let response = await clazzFullInfo(clazzId)
      this.clazz = response.data
      if (this.username) {
        await this.checkEnroll()
      }
      this.isLoaded = true
    },
    async checkEnroll () {
      let response = await checkEnrolRecord(this.clazz.uuid)
      this.enrollCheck = response.data
    },
    backToExplore () {
      this.$router.back()
      // this.$router.push('/explore')
    },
    gotoClazzmanage () {
      this.$router.push('/manage/clazz/' + this.clazz.uuid)
    }
  }
}
</script>

<style scoped lang="scss">
.clazz {
  // background-color: #f8f8f8;
  .headimg {
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
  .header {
    .cover {
      width: 750px;
      height: 375px;
      object-fit: cover;
    }
    .info {
      padding: 25px 25px 0 25px;
      .title {
        font-size: 40px;
        font-weight: bold;
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .btn {
          font-size: 26px;
          width: 135px;
          height: 50px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #fff;
          border: 1PX solid #ebedf0;
          border-radius: 12px;
          background-color: #f5222d;
        }
      }
      .subinfo {
        font-size: 26px;
        color: #9c9c9c;
        margin-top: 10px;
      }
    }
  }
  .render-html {
    font-size: 28px;
  }
  .clazz_part {
    padding: 20px 25px 0 25px;
    margin-bottom: 100px;
    .header {
      font-size: 34px;
    }
    .content {
      font-size: 28px;
      padding: 25px 0;
    }
  }
  .clazz_rule {
    .index {
      display: inline-block;
      width: 30px;
      text-align: center;
    }
    .detail {
      color: #8f8e8e;
      padding-left: 20px;
      .item {
        padding-bottom: 2px;
      }
    }
  }
  .clazz_leader {
    padding: 25px;
    .leader_header {
      display: flex;
      align-items: center;
      font-size: 30px;
      color: #5a728e;
      .headimg {
        width: 90px;
        height: 90px;
        margin-right: 20px;
      }
    }
    .leader_intro {
      margin-left: 110px;
      margin-top: 5px;
      font-size: 26px;
    }
  }
  .empty {
    justify-content: flex-start;
  }
  .hg_cell__value {
    color: #f5222d;
  }
  .mask {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0.6;
    z-index: 999;
    img {
      position: fixed;
      width: 550px;
      right: 0;
    }
  }
  .weixin_contract {
    padding: 30px 0;
    text-align: center;
  }
}
</style>
